import { render, staticRenderFns } from "./Contratacion.vue?vue&type=template&id=01547940"
import script from "./Contratacion.vue?vue&type=script&lang=js"
export * from "./Contratacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01547940')) {
      api.createRecord('01547940', component.options)
    } else {
      api.reload('01547940', component.options)
    }
    module.hot.accept("./Contratacion.vue?vue&type=template&id=01547940", function () {
      api.rerender('01547940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/Contratacion.vue"
export default component.exports